import { AlkLogger } from '@alk/core';
import { FORWARD_STREAM_ADAPTER_SERVICE, IForwardStreamAdapterService } from '../../message-adapters/forward-stream-adapter';
import { ForwardPriceRequest, IForwardQuote, IPriceService } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { ISelectedClientService, SELECTED_CLIENT_SERVICE } from '../../selected-client';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { NEVER, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { validatePadRequest } from './fwd-price.utils';

@injectable()
export class FwdPriceService implements IPriceService {

    @inject(FORWARD_STREAM_ADAPTER_SERVICE) private readonly fwdPriceAdapter: IForwardStreamAdapterService;
    @inject(SELECTED_CLIENT_SERVICE) private readonly selectedClientSrv: ISelectedClientService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    quoteObservable(request: ForwardPriceRequest): Observable<IForwardQuote> {

        AlkLogger.debug(`[FwdPriceService#request] requested price with: ${ JSON.stringify(request) }`);

        const validationResult = validatePadRequest(request);

        if (Boolean(validationResult)) {
            return NEVER;
        }

        const requestWithClient = { ...request, clientId: this.selectedClientSrv.getCurrent()?.id };

        AlkLogger.debug('[FwdPriceService#quoteObservable] requestWithClient: ', requestWithClient);
        return this.fwdPriceAdapter.priceObservable(requestWithClient).pipe(
            takeUntil(this.sessionLifeCycle.destroyObservable()),
        );
    }
}
